// [commons] widget

import { BuyerServerTransactionStatus } from '@wix/cashier-common/dist/src/enums/transactions/BuyerServerTransactionStatus';
import { ClientTransactionStatus } from '@wix/cashier-common/dist/src/enums/transactions/ClientTransactionStatus';

export function serverToClientStatusMap(serverType: BuyerServerTransactionStatus): ClientTransactionStatus {
  switch (serverType) {
    case BuyerServerTransactionStatus.Initialization:
    case BuyerServerTransactionStatus.Initialized:
    case BuyerServerTransactionStatus.PendingBuyer:
    case BuyerServerTransactionStatus.PendingMerchant:
    case BuyerServerTransactionStatus.InProcess:
      return ClientTransactionStatus.Pending;

    case BuyerServerTransactionStatus.Approved:
      return ClientTransactionStatus.Successful;

    case BuyerServerTransactionStatus.Offline:
      return ClientTransactionStatus.Offline;

    case BuyerServerTransactionStatus.PartialRefund:
      return ClientTransactionStatus.PartiallyRefunded;

    case BuyerServerTransactionStatus.Refund:
      return ClientTransactionStatus.Refunded;

    case BuyerServerTransactionStatus.Declined:
    case BuyerServerTransactionStatus.Failed:
    case BuyerServerTransactionStatus.Timeout:
      return ClientTransactionStatus.Failed;

    case BuyerServerTransactionStatus.BuyerCanceled:
      return ClientTransactionStatus.Cancelled;

    case BuyerServerTransactionStatus.ChargeBack:
      return ClientTransactionStatus.Chargeback;

    case BuyerServerTransactionStatus.Undefined:
    default:
      return ClientTransactionStatus.Undefined;
  }
}

export function isFailedStatus(status: BuyerServerTransactionStatus): boolean {
  return serverToClientStatusMap(status) === ClientTransactionStatus.Failed;
}

export function isCancelledStatus(status: BuyerServerTransactionStatus): boolean {
  return serverToClientStatusMap(status) === ClientTransactionStatus.Cancelled;
}
